







































































































































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import tableModel from '../../components/table/tableModel.vue';
import PmModalBox from '../../components/PmModalBox.vue';
import notEmptyFun from '../../utils/notEmptyFun';
import moment from 'moment';
//  短息通知提醒
//  https://cloud.tencent.com/document/product/382/8414
@Component({
  components: {
    Loading,
  },
})
export default class Purchaseing extends Vue {
  private user: any;
  private spinning = false;
  private selectDataJson: any = [];
  private moment: any = moment;
  private queryID: any = '0';
  private payTypeDisabled: boolean = false;
  private dataJson: any = {
    id: '',
    pmName: '',
    brand: '',
    asin: '',
    productName: '',
    productNumber: '',
    store: '',
    purchaseType: '产品',
    packingType: '',
    purchaseNumber: 0,
    price: 0,
    factoryName: '',
    demandTime: this.moment(new Date()).format('YYYY-MM-DD'),
    ads: '',
    link: '',
    remarks: '',
    // =======================================
    purchaser: '', // 采购人
    shippingSchedule: '', // 出货计划
    payType: '全款', // 付款类型  全款  分期
    payNumber: 1, // 付款总次数
    payData: [ // 付款总数据
      // {
      //   masterId: this.queryID, // 采购ID  this.dataJson['id']
      //   payId: `${index + 1}_${this.queryID}`, // 采购id 唯一
      //   factoryPayingNumber: 1, // 当前是第几次的付款 从1 开始
      //   factoryPayTime: this.moment(new Date()).format('YYYY-MM-DD'), // 预期时间
      //   factoryPeople: '', // 收款人
      //   factoryBankNumber: '', // 收款账户
      //   factoryBank: '', // 收款银行
      //   factoryPayNumber: '', // 收款金额
      //   factoryBankBranch: '', // 支行名称
      //   remarks: '', // 付款备注
      //   financeStatus: 0, // 0 初始状态  1 已付款  2 pending
      // },
    ],
    goodsNumber: 1, // 工厂发货的总数
    goodsData: [  // 工厂发货总数据  freight 货物;货运
      // {
      //   masterId: this.queryID, // 采购ID  this.dataJson['id']
      //   goodsId: '', // 商品id 唯一  `${index + 1}_${this.queryID}`
      //   goodsingNumber: 0, // 当前是第几次的发货 从1 开始
      //   goodsDeliverTime: this.moment(new Date()).format('YYYY-MM-DD'),  // 发货时间
      //   goodsDeliverNumber: 0, // 发货数量
      //   trackingType: '',
      //   tracking: '',
      //   goodsDeliverPay: 0, // 货物运费
      //   goodsAds: '', // 收货地址
      //   remarks: '', // 备注详情
      //   goodsStatus: 0, // 工厂发货状态  0 创建   1已收货  2 pending
      // },
    ],
  };
  private async mounted() {
    this.user = storage.get('user');
    if (this.user) {
      if (this.$router.currentRoute.query && this.$router.currentRoute.query.id) {
        // 获取信息  自动填写信息
        const id = this.$router.currentRoute.query.id;
        this.queryID = id;
        await this.getIDData(id);
        this.getIDPayOrGoodsData('all', id);
      }
      this.getSelectData();
    } else {
      console.log('please login');
      this.$router.push({
        path: '/login',
      });
    }
  }
  private async freightDataOK(data: any) {
    const dataJson = this.dataJson;
    const arr = [ 'purchaser'];
    if (!notEmptyFun(dataJson, arr)) {
      this.$message.warning('*必填字段不能为空!!!');
      return false;
    }
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/changeGoodsStatus';
    //  给支付的信息 增加 goodsData 和  下标
    dataJson.goodsData.forEach((data3: any, index: number) => {
      this.$set(dataJson.goodsData[index], 'goodsId', `${index + 1}_${this.queryID}`);
      this.$set(dataJson.goodsData[index], 'goodsingNumber', index + 1);
    });
    data.goodsStatus = 1;
    const args =  {
      data,
      dataJson,
    };
    this.axios.post(url, args).then((res) => {
      const dataJson1 = res.data;
      if (dataJson1.code === 12) {
        this.getIDPayOrGoodsData('goods', this.queryID);
      } else {
        this.spinning = false;
      }
    });
  }
  private async getIDData(id: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      this.spinning = true;
      // 清空数组  112-0006206-7613056
      const url: string = '/api/getPurchaseingList';
      const args = {
        id,
      };
      this.axios.post(url, args).then((res) => {
        const dataJson = res.data.data[0];
        that.dataJson = Object.assign({}, that.dataJson, dataJson);
        that.spinning = false;
        resolve();
      });
    });
  }
  private async getIDPayOrGoodsData(type: string, id: any) {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/getIDPayOrGoodsData';
    const args = {
      id,
    };
    this.axios.post(url, args).then((res) => {
      const dataJson = res.data.data;
      // payData 如果采购着不是第一次进来,则按照数据库走,  否则自己push一个
      if (type === 'all') {
        if (dataJson[0].length > 0 ) {
          that.dataJson.payData = Object.assign([], that.dataJson.payData, dataJson[0]);
          // 判断 付款类型是否可以改变,如果 已经有财务付款完成,则不能修改付款类型,    如果 分期付款 和 全款 类型改变,
          dataJson[0].every((data: any) => {
            if (data.financeStatus === 3) {
              that.payTypeDisabled = true;
              return false;
            }
            return true;
          });
        } else {
          // this.pushPayObj();
          this.pushPayObj();
        }
      }
      // goodsData 如果采购着不是第一次进来,则按照数据库走,  否则自己push一个
      if (dataJson[1].length > 0) {
        that.dataJson.goodsData = Object.assign([], that.dataJson.goodsData, dataJson[1]);
      } else {
        this.addGoods('new');
      }
      that.spinning = false;
    });
  }
  private async getSelectData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getSelectTracking';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      that.selectDataJson = res.data.data;
      that.spinning = false;
    });
  }
  // 添加分期
  private addPayStages() {
    this.$set(this.dataJson, 'payNumber', this.dataJson.payNumber + 1);
    const payObj = {
      masterId: this.queryID, // 采购ID  this.dataJson['id']
      payId: '', // 采购ID  `${index + 1}_${this.queryID}`
      factoryPayingNumber: this.dataJson.payNumber, // 付款的index 从1 开始
      factoryPayTime: this.moment(new Date()).format('YYYY-MM-DD'), // 预期时间
      factoryPeople: '', // 收款人
      factoryBankNumber: '', // 收款账户
      factoryBank: '', // 收款银行
      factoryPayNumber: 0, // 收款金额
      factoryBankBranch: '', // 支行名称
      remarks: '', // 付款备注
      financeStatus: 0, // 0 初始状态  1 已付款  2 pending
    };
    this.dataJson.payData.push(payObj);
  }
  private async payDataDelete(index: number) {
    // 数据库删除
    const payJson = this.dataJson.payData[index];
    if (payJson && payJson.id) {
      await this.payOrGoodsDelete('pay', payJson.id);
      // 本地删除
      this.dataJson.payData.splice(index, 1);
      this.$set(this.dataJson, 'payNumber', this.dataJson.payNumber - 1);
      // 保存更新
      this.createOK('Refresh');
    } else {
      // 本地删除
      this.dataJson.payData.splice(index, 1);
      this.$set(this.dataJson, 'payNumber', this.dataJson.payNumber - 1);
    }
  }
  private async goodsDataDelete(index: number) {
    const that = this;
    const goodsJson = this.dataJson.goodsData[index];
    if (goodsJson && goodsJson.id) {
      await this.payOrGoodsDelete('goods', goodsJson.id);
      this.dataJson.goodsData.splice(index, 1);
      this.$set(this.dataJson, 'goodsNumber', this.dataJson.goodsNumber - 1);
      // 这里面有保存
      this.createOK('Refresh');
    } else {
      this.dataJson.goodsData.splice(index, 1);
      this.$set(this.dataJson, 'goodsNumber', this.dataJson.goodsNumber - 1);
      this.dataJson.goodsData.forEach((list: any, ind: number) => {
        that.$set(that.dataJson.goodsData, 'goodsingNumber', ind + 1);
      });
    }
  }
  private payOrGoodsDelete(type: string, id: string) {
    return new Promise((reslove, reject) => {
      const that = this;
      this.spinning = true;
      const url: string = '/api/deletePayOrGoods';
      const args = {
        type,
        id,
      };
      this.axios.post(url, args).then((res) => {
        that.spinning = false;
        reslove(res);
      });
    });
  }
  private createOK(type?: string) {
    const that = this;
    const dataJson = this.dataJson;
    const arr = [ 'pmName', 'brand', 'asin', 'productName', 'productNumber', 'store', 'purchaser'];
    if (!notEmptyFun(dataJson, arr)) {
      this.$message.warning('*必填字段不能为空!!!');
      return false;
    }
    this.spinning = true;
    const url: string = '/api/saveChangePurchaseing';
    //  给支付的信息 增加payid 和  下标
    this.dataJson.payData.forEach((data: any, index: number) => {
      this.$set(this.dataJson.payData[index], 'payId', `${index + 1}_${this.queryID}`);
      this.$set(this.dataJson.payData[index], 'factoryPayingNumber', index + 1);
    });
    //  给支付的信息 增加 goodsData 和  下标
    this.dataJson.goodsData.forEach((data: any, index: number) => {
      this.$set(this.dataJson.goodsData[index], 'goodsId', `${index + 1}_${this.queryID}`);
      this.$set(this.dataJson.goodsData[index], 'goodsingNumber', index + 1);
    });
    const args = dataJson;
    this.axios.post(url, args).then((res) => {
      that.spinning = false;
      if (type !== 'Refresh') {
        this.$router.push({
          path: '/flow/PurchaseingList',
        });
      }
    });
  }
  private cancel() {
   this.$router.go(-1);
  }
  private deleteMysqlPayIdData(id: string) {
    return new Promise((resolve, reject) => {
      const url = '/api/deletePayOrGoods';
      const args = {
        type: 'pay',
        id,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }
  private updataMysqlPurchasePayNumber(id: string) {
    return new Promise((resolve, reject) => {
      const url = '/api/updataPurchasePayNumber';
      const args = {
        payNumber: 0,
        id,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }
  private async handleChangePayType(value: string) {
    // 查看数据库中是否有数据, 检查dataJson中的payData中的数据 id是否为空,为空则是刚刚创建的.
    const payData = this.dataJson.payData;
    for (const pay of payData) {
      if (pay.id) {
        // 1 删除数据库中的数据,  如果 数据库中已经有数据, 怎么付款呢?
        await this.deleteMysqlPayIdData(pay.id);
      }
    }
    // 防止bug出现, 每次切换付款类型, 主表的payNumber 更改为 0;  保存时, 主表的payNumber 会根据 全款 和 分期次数 更改
    const masterID = this.dataJson.id;
    if (masterID) {
      await this.updataMysqlPurchasePayNumber(masterID);
    }
    // 2 删除本地的数据,添加一个新的数据,  创建一个新的payObj, 删除之前的payObj
    this.pushPayObj();
  }
  private pushPayObj() {
    const payObj = {
      masterId: this.queryID, // 采购ID  this.dataJson['id']
      payId: '', // 采购ID `${index + 1}_${this.queryID}`
      factoryPayingNumber: 1, // 付款的index 从1 开始
      factoryPayTime: this.moment(new Date()).format('YYYY-MM-DD'), // 预期时间
      factoryPeople: '', // 收款人
      factoryBankNumber: '', // 收款账户
      factoryBank: '', // 收款银行
      factoryPayNumber: 0, // 收款金额
      factoryBankBranch: '', // 支行名称
      remarks: '', // 付款备注
      financeStatus: 0, // 0 初始状态  1 已付款  2 pending
    };
    this.dataJson.payData.splice(0, this.dataJson.payData.length);
    this.dataJson.payData.push(payObj);
    this.$set(this.dataJson, 'payNumber', 1);
  }
  private addGoods(type: string) {
    if (type === 'old') {
      // this.$set(this.dataJson, 'goodsNumber', this.dataJson.goodsNumber + 1);
    }
    this.$set(this.dataJson, 'goodsNumber', this.dataJson.goodsNumber + 1);

    // 添加发货
    const goodsObj = {
      masterId: this.queryID, // 采购ID  this.dataJson['id']
      goodsId: '', // 采购ID  this.dataJson['id']
      goodsingNumber: this.dataJson.goodsNumber, // 当前是第几次的发货 从1 开始
      goodsDeliverTime: this.moment(new Date()).format('YYYY-MM-DD'),  // 发货时间
      goodsDeliverNumber: 0, // 发货数量
      trackingType: '',
      tracking: '',
      goodsDeliverPay: 0, // 货物运费
      goodsAds: '', // 收货地址
      remarks: '', // 备注详情
      goodsStatus: 0, // 工厂发货状态  0 创建   1已收货  2 pending
    };
    this.dataJson.goodsData.push(goodsObj);
  }
  private async handleChange(value: string, type: string, asinType: string) {
    const that = this;
    let args = {};
    if ( type === 'productName' ) {
      args = {
        productName: value,
      };
      await this.getTrackingAll(args);
    } else if ( type === 'productNumber' ) {
      args = {
        productNumber: value,
      };
      await this.getTrackingAll(args);
    } else if ( type === 'pmName' ) {
      const url = '/api/getPMTrackingProAsin';
      args = {
        pmName: value,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          Object.assign(this.dataJson, {
            productName: '',
            productNumber: '',
            asin: '',
            store: '',
            brand: '',
          });
          // 根据pmName 更新 产品名称 和 asin
          that.selectDataJson.splice(2, 1, res.data.data[0]);
          that.selectDataJson.splice(1, 1, res.data.data[1]);
        }
      });
    }
  }
  private getTrackingAll(args: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      // 根据 productNumber 自动填写 其他确认的数据;
      const url = '/api/getTrackingAll';
      this.axios.post(url, args).then((res) => {
        const data = res.data.data[0];
        Object.assign(this.dataJson, {
          pmName: data.pmName,
          productName: data.productName,
          productNumber: data.productNumber,
          asin: data.asin,
          store: data.store,
          brand: data.brand,
        });
        resolve();
      });
    });
  }
  private onChangeDatePicker() {
    //
  }
  private async getData() {
    const that = this;
    this.spinning = true;
    const url: string = '/api/getOrderDetails';
    const args = {
    };
    const data = await this.axios.post(url, args);
    this.spinning = false;
  }

}
